import axios from 'axios';
import { getToken, getAuth } from '../utils/auth';
import logger from '../utils/logger';
import * as AuthUtils from '../utils/auth';

export const getBaseUrl = () => {
  switch (window.location.hostname) {
    case 'fintecimal-nodos.herokuapp.com':
      return 'https://fintecimal-nodos.herokuapp.com/api';
    case 'fintecimal-nodos-test.herokuapp.com':
      return 'https://fintecimal-nodos-test.herokuapp.com/api';
    default:
      // return 'https://fintecimal-nodos.herokuapp.com/api';
      // return 'https://fintecimal-nodos-test.herokuapp.com/api';
      // return 'http://localhost:1337/api';
      return process.env.REACT_APP_BASE_URL;
  }
};

export const createInstance = async (params = { checkToken: false, token: '' }) => {
  const { checkToken, token } = params;
  let newToken = await getToken();
  if (checkToken) {
    const AuthStorageData = await getAuth();
    logger({
      title: 'AXIOS CONFIG',
      subtitle: 'AUTH STORAGE',
      data: { AuthStorageData },
    });
    logger({
      title: 'AXIOS CONFIG',
      subtitle: 'Token',
      data: { length: newToken?.length, token: newToken },
    });
    if (!newToken) {
      newToken = token;
      await AuthUtils.storeAuth({ token });
    }
  }
  if (!newToken) {
    newToken = token;
  }
  const authorizationHeader = newToken ? { Authorization: `Token ${newToken}` } : {};

  const axiosInstance = axios.create({
    baseURL: getBaseUrl(),
    headers: {
      'Content-Type': 'application/json',
      'x-api-key': 'RD2DAA4-W29MJGZ-PD7WPP6-8892M9D',
      ...authorizationHeader,
    },
    validateStatus: (status) => (
      status >= 200 && status < 300
    ),
  });

  return axiosInstance;
};

export const createInstanceNoToken = () => {
  const axiosInstance = axios.create({
    baseURL: getBaseUrl(),
    headers: {
      'Content-Type': 'application/json',
      'x-api-key': 'RD2DAA4-W29MJGZ-PD7WPP6-8892M9D',
    },
    validateStatus: (status) => (
      status >= 200 && status < 300
    ),
  });

  return axiosInstance;
};

export default createInstance();
